module.exports = __webpack_public_path__ + "img/NewZealand2.ff1a652d.png";